import React, { ReactNode, useEffect } from 'react';
import classNames from 'classnames';
import { getContext } from '@fiverr-private/fiverr_context';
import { SUPPORTED_FIVERR_LOCALES_KEYS } from '@fiverr-private/localization';
import { useImpressionManager } from '@fiverr-private/impressionable';
import { sendMixPanelEvent } from '../../utils/biEvents';
import { MP_SHOW_PAGE_NAME } from '../../utils/biEvents/events/mixPanelEvents';
import { MIXPANEL_EVENT_TYPES } from '../../utils/types/mixpanelEventTypes';

import './style.scss';

interface EntryWrapperProps {
    removeBottomSpace?: boolean;
    children?: ReactNode;
}

const EntryWrapper = ({ removeBottomSpace = false, children }: EntryWrapperProps) => {
    const { locale, isMobile } = getContext();
    useImpressionManager();

    useEffect(() => {
        sendMixPanelEvent({
            eventName: MP_SHOW_PAGE_NAME,
            eventType: MIXPANEL_EVENT_TYPES.PAGE_VIEW,
        });
    }, []);

    const shouldApplyStyles = locale === SUPPORTED_FIVERR_LOCALES_KEYS.EN_US && !isMobile;

    return (
        <div
            className={classNames('logged-out-homepage', 'is-revamp', {
                'p-b-0': removeBottomSpace,
                'logged-out-homepage-de': locale === SUPPORTED_FIVERR_LOCALES_KEYS.DE_DE,
                'logged-out-homepage-test': shouldApplyStyles,
            })}
        >
            {children}
        </div>
    );
};

export default EntryWrapper;
